module.exports = __webpack_public_path__ + "img/183e1ab.png";